export const VehicleTypeEnum = {
    Car: 1,
    Truck: 2,
    Moto: 3
};

export const allVehicleTypes = [
    {id: VehicleTypeEnum.Car, label: 'car', icon: 'car'},
    {id: VehicleTypeEnum.Truck, label: 'truck', icon: 'truck'},
    {id: VehicleTypeEnum.Moto, label: 'moto', icon: 'motorcycle'}
];



// WEBPACK FOOTER //
// ./src/scripts/core/vehicleType/constants.js